<template>
  <div class="logo-card-horizontal" :class="theme">
    <div class="logo-card-horizontal-content">
      <img src="@/assets/img/svg/logo.svg" width="135" />
      <p>
        <slot
          ><strong>Ficou com alguma dúvida?</strong></slot
        >
      </p>
      <router-link :to="{ name: 'page_contact' }" class="button button-orange">
        Entre em contato
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: ["theme"],

  computed: {
    buttonClass() {
      return { orange: "button-blue", blue: "button-orange" }[this.theme];
    },
  },
};
</script>

<style>
</style>
